"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zuoraToPulseOrigin = zuoraToPulseOrigin;
/**
 * Converts the zuroa params to a pulse origin object usable by the pulse-tracker
 */
function zuoraToPulseOrigin(data) {
    return {
        campaign: data.utm_campaign,
        channel: data.utm_medium,
        content: data.utm_content,
        source: data.utm_source,
        terms: data.utm_term,
        xDomainId: data.x_domain_id,
    };
}
//# sourceMappingURL=zuora-to-pulse-origin.js.map